import { AssetsEnum } from '@/config';
import { InvestigationHistoryItemData } from '@/redux/models';
import { InvestigationHistoryItem } from '@/api';

function getAmountPrecision(
  item: InvestigationHistoryItemData | InvestigationHistoryItem,
) {
  if (
    item.tokenData &&
    Object.hasOwnProperty.call(item.tokenData, 'precision')
  ) {
    return 10 ** item.tokenData.precision;
  }

  switch (item.asset) {
    case AssetsEnum.ETH:
    case AssetsEnum.ETC:
    case AssetsEnum.BSC:
    case AssetsEnum.BNB:
    case AssetsEnum.TON:
      return 1000000000;
    case AssetsEnum.TRX:
      return 1000000;
    case AssetsEnum.DOT:
      return 10000000000;
    case AssetsEnum.XLM:
      return 10000000;
    case AssetsEnum.ARB:
    case AssetsEnum.OP:
    case AssetsEnum.BASE:
    case AssetsEnum.MATIC:
    case AssetsEnum.CELO:
      return 1000000000000000000;
    case AssetsEnum.SOL:
      return 1000000000;
    default:
      return 100000000;
  }
}

export default getAmountPrecision;
